module.exports = "<app-angular-loader name=\"AppLoader\"></app-angular-loader>\n<div (click)=\"onCLickPage()\">\n\n  <router-outlet></router-outlet>\n\n\n\n  <div class=\"custRow\" style=\"position:fixed;left:0;bottom:2%;z-index: 9999;\">\n    <!-- <img [src]=\"auditImgSrc\" alt=\"counterauditlogo\" style=\"margin-left:10%;\" width=\"150\" height=\"35\">-->\n    <p style=\"color: black;padding-left: 10px;\">Version {{version}} (Official Build)</p>\n  </div>\n\n</div>\n<app-modals (onModalSubmit)=\"doOnModalSubmit($event)\" [mmOptions]=\"AppMMOtions\"></app-modals>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main